<div class="container" *ngIf="!property">
    <div class="row justify-content-center mt-5 mb-5">
        <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
    </div>
</div>
<div class="container" *ngIf="property">
        <div class="main-property">
            <div id="property-title" class="mb-3">
                <div class="title-of-ad w-100">
                    <h2>
                        {{ property.title }}
                    </h2>
                </div>
            </div>
            <div class="gallery">
                <div class="w-100" *ngIf="galleryImages.length > 0">
                    <ngx-gallery [options]="galleryOptions" [(images)]="galleryImages" class="ngx-gallery"></ngx-gallery>
                </div>
            </div>
            <div id="location-sharing-price" class="pb-2">
                <div class="w-100 pb-3">
                    <div class="w-100 d-flex justify-content-between align-items-center py-2">
                        <p class="m-0">{{ address }} | <a class="anchor-map" [routerLink]='"."' fragment="map-section"><i class="fas fa-map-marker-alt mr-2"></i>See Map</a></p>
                        <button *ngIf="loggedIn && notFavourite" mat-raised-button class="favorite-button" (click)="addToFavourite()" aria-label="Add to favorite">
                            <mat-icon>favorite</mat-icon> Add to favourite
                        </button>
                        <button *ngIf="loggedIn && !notFavourite" mat-button class="favorited-button" (click)="removeFromFavourite()" aria-label="Remove from favorite">
                            <mat-icon>favorite</mat-icon> Added to favourite
                        </button>
                    </div>
                    <div class="w-100 mt-2 d-flex">
                        <div class="price mr-4">
                            NPR {{ property.price }}
                        </div>
                        <div id="my-inline-share"></div>
                    </div>
                </div>
                <hr class="divider">
            </div>
            <div id="property-info">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-8">
                        <div class="agent-owner-info">
                            <div class="contact-detail pb-4">
                                <p class="seller-name">{{ property.iam }}: <span class="black-text">{{(seller | async)?.user.firstName}} {{(seller | async)?.user.lastName}}</span> | <a href="tel:'{{(seller | async)?.user.phone}}'"><img src="assets/call.png">  <span class="black-text">  {{(seller | async)?.user.phone}}</span></a></p>
                                <p class="mt-3"><a class="body-button theme-button" href="mailto:'{{(seller | async)?.user.Credential.email}}'">Email {{ property.iam }}</a></p>
                            </div>
                        </div>
                        <div class="feature-text">
                            <div class="row">
                                <div class="col-4">
                                    <strong>Property Id</strong>
                                </div>
                                <div class="col-8">
                                    <span>: {{ property.aliasId }}</span>
                                </div>
                                <div class="col-4" *ngIf="property.totalArea">
                                    <strong>Total Area</strong>
                                </div>
                                <div class="col-8" *ngIf="property.totalArea">
                                    <span>: {{ property.totalArea }} (Bigha)</span>
                                </div>
                                <div class="col-4" *ngIf="property.houseArea">
                                    <strong>Property Area</strong>
                                </div>
                                <div class="col-8" *ngIf="property.houseArea">
                                    <span>: {{ property.houseArea }} (Ropani)</span>
                                </div>
                                <div class="col-4" *ngIf="property.floor">
                                    <strong>Number of Floors</strong>
                                </div>
                                <div class="col-8" *ngIf="property.floor">
                                    <span>: {{ property.floor }}</span>
                                </div>
                                <div class="col-4" *ngIf="property.distFromRoad">
                                    <strong>Distance</strong>
                                </div>
                                <div class="col-8" *ngIf="property.distFromRoad">
                                    <span>: {{ property.distFromRoad }} from main road</span>
                                </div>
                                <div class="col-4">
                                    <strong>Posted On</strong>
                                </div>
                                <div class="col-8">
                                    <span>: {{ property.approvalDate }}</span>
                                </div>
                                <div class="col-4">
                                    <strong>Total Ad Views</strong>
                                </div>
                                <div class="col-8">
                                    <span>: {{ property.totalView }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="description">
                            <h4 class="pt-5 pb-3"><strong>Property Description</strong></h4>
                            <div [innerHTML]="property.details"></div>
                        </div>
                        <div class="facilities">
                            <h4 class="pt-5 pb-4"><strong>Facilites and Amneties</strong></h4>
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.electricity == 'Available'">
                                    <div class="facility-inner">
                                        <img src="assets/electricity.png"> Electricity
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.waterSupply == 'Available'">
                                    <div class="facility-inner">
                                        <img src="assets/water-supply.png"> Water Supply
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.gasSupply == 'Available'">
                                    <div class="facility-inner">
                                        <img src="assets/gas-supply.png"> Gas Supply
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.telecommunication == 'Available'">
                                    <div class="facility-inner">
                                        <img src="assets/telecommunication.png"> Telecommunication
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.parking == 'Available'">
                                    <div class="facility-inner">
                                        <img src="assets/sign.png"> Parking
                                    </div>
                                </div>
                            </div>
                            <div class="other-facilities pb-5" *ngIf="otherFacilities.length > 0">
                                <h4 class="pt-4 pb-4"><strong>Additional Facilities</strong></h4>
                                <div class="w-100" *ngFor="let facility of otherFacilities">
                                    {{ facility.title }} : <span class="ml-3">{{ facility.details }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4">
                        <div class="right-ad-space" *ngIf="firstAd || secondAd || thirdAd">
                            <div class="right-ad-md mb-3">
                                <a *ngIf="firstAd" [href]="firstAd.link"><img [src]="firstAd.imagePath" style="height: 400px" alt="firstAd"></a>
                            </div>
                            <div class="right-ad-sm mb-3">
                                <a *ngIf="secondAd" [href]="secondAd.link"><img [src]="secondAd.imagePath" style="height: 200px" alt="secondAd"></a>
                            </div>
                            <div class="right-ad-lg">
                                <a *ngIf="thirdAd" [href]="thirdAd.link"><img [src]="thirdAd.imagePath" style="height: 500px" alt="firstAd"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div class="prop-details" id="map-section">
                    <section>
                        <h4 class="text-center mt-5 mb-4"><strong>Location</strong></h4>
                        <div class="row mb-3">
                            <div class="form-group col-md-8 mt-2 mb-2">
                                <input #location placeholder="Origin" class="form-control">
                            </div>
                            <div class="form-group col-md-4 mt-2 mb-2">
                                <select [(ngModel)]="selectedMode" (ngModelChange)="calcRoute()">
                                    <option value="DRIVING">Driving</option>
                                    <option value="WALKING">Walking</option>
                                    <option value="BICYCLING">Bicycling</option>
                                    <option value="TRANSIT">Transit</option>
                                  </select>
                            </div>
                        </div>
                        <div class="row justify-content-center mt-5 mb-5" *ngIf="!mapLoaded">
                            <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
                        </div>
                        <div class="user-location-map" #mapContainer id="map"></div>
                        <div class="directions" #directionsPanel id="directionsPanel"></div>
                    </section>
                    <hr class="divider">
                    <section class="pt-4" *ngIf="similarProperties.length > 0">
                        <h4 class="text-center mb-5"><strong>Similar Properties</strong></h4>
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-3 mt-1 mb-4" *ngFor="let property of similarProperties">
                                <a [routerLink]="['/property/'+property.id]">
                                    <div class="prop-contents">
                                        <div class="cont-image">
                                            <img [src]="property.featuredImage">
                                        </div>
                                        <div class="cont-caption">
                                            <p class="caption-title mb-4">
                                                {{ property.title }}
                                            </p>
                                            <p><img style="display: inline; margin-right: 5px;" src="assets/location_small.png">{{ property.address }}</p>
                                            <p class="property-price">रु {{ property.price }}</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    </div>